import { useMutation } from "react-query";
import http from "infra/http";

function useDeleteRetornoBancario() {
  return useMutation(
    (id: string) => {
      return http.delete(`/v1/retorno-bancario/${id}`);
    },
    { retry: false }
  );
}

export default useDeleteRetornoBancario;
